module.exports = __webpack_public_path__ + "static/wamodern-ec712a7e9581e62eadba939e0268ed86.png";